import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useGeneralDetails } from "../Announcements.hook";
import { fields } from "../constants";

export const AddEditNewGeneral = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: Data,
    error,
    isLoading: isLoadingData,
    isError,
    refetch: refectchData,
  } = useGeneralDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingDataById,
    refetch: refectchDataById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refectchDataById();
    }
    if (query.get("editId")) {
      refectchData();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
      field_title_general_en: dataById
        ? decodeHTML(dataById.payload.field_title_general_en)
        : Data
          ? decodeHTML(Data.field_title_general_en)
          : "",
      field_title_general_ms: dataById ? decodeHTML(dataById.payload.field_title_general_ms) : Data ? decodeHTML(Data.field_title_general_ms) : "",
      field_title_general_zh: dataById
        ? decodeHTML(dataById.payload.field_title_general_zh)
        : Data
          ? decodeHTML(Data.field_title_general_zh)
          : "",
      field_description_general_en: dataById
        ? decodeHTML(dataById.payload.field_description_general_en?.value)
        : Data
          ? decodeHTML(Data.field_description_general_en)
          : "",
      field_description_general_ms: dataById ? decodeHTML(dataById.payload.field_description_general_ms?.value) : Data ? decodeHTML(Data.field_description_general_ms) : "",
      field_general_description_zh: dataById
        ? decodeHTML(dataById.payload.field_general_description_zh?.value)
        : Data
          ? decodeHTML(Data.field_general_description_zh)
          : "",
      field_circular_date: dataById
        ? decodeHTML(dataById.payload.field_circular_date)
        : Data
          ? decodeHTML(Data.field_circular_date)
          : "",
      field_page_published_circular: dataById ? dataById.payload.field_page_published_circular : Data ? Data.field_page_published_circular : "",
    },
    fields: fields.general,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let publishKey: any=[
      'field_page_published_circular'
    ]
    for (const key of publishKey) {
      data[key] = !!data[key];
    }  
    
    let descKeys: any = [
      "field_general_description_zh",
      "field_description_general_ms",
      "field_description_general_en",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "ANNOUNCEMENT",
      subModule: "general",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        title: data?.field_title_general_en,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refectchDataById();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingDataById}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} General`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingDataById || isLoadingData}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${magpHost}/api/general-creation${(Data?.id || dataById?.payload?.id) ? `/${Data?.id || dataById?.payload?.id}` : ""}`,
            `${query.get("editId") || query.get('type')==='update' ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get('type')==='update' ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
